export default __webpack_public_path__ + "static/media/ms3.0a6bd143.jpg";